<template>
    <div class="px-3 py-2">
        <v-form
            ref="forcar"
            lazy-validation
        >
            <b-sidebar ref="purchaseViewer" id="viewPurch" backdrop width="90%" aria-labelledby="sidebar-no-header-title" no-header style="direction:ltr" right :title="lang.add_car" shadow >
                <template #default="{ hide }">
                    <div class="m-1 text-start" style="direction:rtl">
                        <div style="width:120px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                            <span>{{bobtitle}}</span>
                        </div>
                        <div @click="hide" id="viewBillHide" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                            <span>{{lang.close}}</span>
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <div v-if="billifno.id" class="px-3 py-2" style="direction:rtl">
                        <div class="myBtn backBlack" :style="`direction:${lang.dir};`">
                            <b-button type="button" class="btnRow c_darkblue" id="addPurch" variant="success" :disabled="workingAction" @click='deleteAll()' style="width:120px;" v-if="shwoDelInv && (billifno.jvnum == 0 || billifno.jvnum == '') && billifno.is_returned == 0">{{ lang.delete_invoice }}</b-button>
                            <b-button type="button" class="btnRow backRed" id="addPurch" variant="success" @click='deleteSelected()' style="width:120px;" v-if="shwoDelPartInv && (billifno.jvnum == 0 || billifno.jvnum == '') && billifno.is_returned == 0">{{ lang.delete_selected }}</b-button>
                            <b-button type="button" class="btnRow c_darkslateblue" id="addPurch" variant="success" @click='returnAll()' style="width:120px;display:none;" v-if="shwoDelInv && billifno.is_returned == 0 && billifno.jvnum != 0 && shoReturnInvo">{{lang.return_invoice}}</b-button>
                            <b-button type="button" class="btnRow c_darkorange" id="addPurch" variant="success" @click='returnSelected()' style="width:120px;display:none;" v-if="shwoDelPartInv && billifno.is_returned == 0 && billifno.jvnum != 0 && billifno.jvnum != ''">{{lang.return_selected}}</b-button>
                            <b-button style="font-size:1.1rem;border:2px solid #fff !important;background:blue !important;width:120px;color:#fff;" class="mytab2 btn btn-sm btn-success m-2" @click="showAttached()" v-b-toggle.add_gallery>{{lang.attachement}}</b-button>
                            <b-button style="font-size:1.1rem;border:2px solid #fff !important;background:#036 !important;width:140px;color:#fff;" class="mytab2 btn btn-sm m-2" v-if="canEdit" :disabled="savingBill" @click="saveBill()">{{ savingBill ? '...' : lang.save }}</b-button>
                            <span v-if="!canEdit" style="display:inline-block;margin:8px;padding:6px 10px;border-radius:5px;background:#eee;color:#555;">الفاتورة مرحلة — الغِ الترحيل لتعديلها</span>
                            <b-button style="font-size:1.1rem;border:2px solid #fff !important;background:red !important;width:120px;color:#fff;" class="mytab2 btn btn-sm btn-success m-2" :disabled="workingAction" @click="deletePost(billifno.id)" v-if="shoCancelPost">{{lang.cancel_post}}</b-button>
                            <b-button style="font-size:1.1rem;border:2px solid #fff !important;background:green !important;width:120px;color:#fff;" class="mytab2 btn btn-sm btn-success m-2" :disabled="workingAction" @click="rePost(billifno.id)" v-if="showPost && billifno.is_returned == 0 && billifno.jvnum == 0">{{lang.repost}}</b-button>
                            <b-button style="font-size:1.1rem;border:2px solid #fff !important;background:green !important;width:120px;color:#fff;" class="mytab2 btn btn-sm btn-success m-2" v-if="billifno.is_returned == 0 && billifno.jvnum == 0" @click="addNewP()" v-b-toggle.add_new_product1>{{lang.add_product}}</b-button>
                        </div>
                        <div class="container">
                            <div><h6 class="backBlack text-center p-2">{{view_title}}</h6></div>
                            <b-table-simple :style="`direction:`+lang.dir">
                                <thead>
                                    <tr>
                                        <th style="background:#000 !important;color:#fff !important;border:1px solid #555;border-bottom:2px solid #fff !important;text-align:center;width:8.33%">{{lang.invoiceno}}</th>
                                        <td style="border:1px solid #555;text-align:center;width:8.33%"><b-form-input v-if="canEdit" class="inborder" v-model="edit.bill_number" /><span v-else>{{ billifno.bill_number }}</span></td>
                                        <th style="background:#000 !important;color:#fff !important;border:1px solid #555;border-bottom:2px solid #fff !important;text-align:center;width:8.33%">{{lang.invoice_date}}</th>
                                        <td style="border:1px solid #555;text-align:center;width:8.33%"><b-form-input v-if="canEdit" class="inborder" type="date" v-model="edit.bill_date" /><span v-else>{{ String(billifno.bill_date).substring(0,10) }}</span></td>
                                        <th style="background:#000 !important;color:#fff !important;border:1px solid #555;border-bottom:2px solid #fff !important;text-align:center;width:8.33%">{{lang.vendor}}</th>
                                        <td style="border:1px solid #555;text-align:center;width:8.33%"><b-form-input v-if="canEdit" class="inborder" v-model="edit.vendor" /><span v-else>{{ billifno.vendor }}</span></td>
                                    </tr>
                                    <tr>
                                        <th style="background:#000 !important;color:#fff !important;border:1px solid #555;border-bottom:2px solid #fff !important;text-align:center;width:8.33%"> {{lang.vendor_vatids}}</th>
                                        <td style="border:1px solid #555;text-align:center;width:8.33%"><b-form-input v-if="canEdit" class="inborder" v-model="edit.vat_number" /><span v-else>{{ billifno.vat_number }}</span></td>
                                        <th style="background:#000 !important;color:#fff !important;border:1px solid #555;border-bottom:2px solid #fff !important;text-align:center;width:8.33%">{{lang.vendor_mobile}}</th>
                                        <td style="border:1px solid #555;text-align:center;width:8.33%"><b-form-input v-if="canEdit" class="inborder" v-model="edit.mobile" /><span v-else>{{ billifno.mobile }}</span></td>
                                        <th style="background:#000 !important;color:#fff !important;border:1px solid #555;border-bottom:2px solid #fff !important;text-align:center;width:8.33%">{{lang.bill_type}}</th>
                                        <td style="border:1px solid #555;text-align:center;width:8.33%"><b-form-select v-if="canEdit" class="selborder" v-model="edit.invtype" :options="invtypes" @change="onVatRuleChange()" /><span v-else>{{ Number(billifno.raw.invtype)===2 ? lang.internal_invoice : lang.purchase_invoice }}</span></td>
                                    </tr>
                                    <tr>
                                        <th style="background:#000 !important;color:#fff !important;border:1px solid #555;border-bottom:2px solid #fff !important;text-align:center;width:8.33%"> {{lang.payment_method}}</th>
                                        <td style="border:1px solid #555;text-align:center;width:8.33%"><b-form-select v-if="canEdit" class="selborder" v-model="edit.paytype" :options="paytypes" /><span v-else>{{ Number(billifno.cashajl)===2 ? lang.none_paid_invoice : (paytypes.find(type=>Number(type.value)===Number(billifno.raw.paytype)) || {}).text }}</span></td>
                                        <th style="background:#000 !important;color:#fff !important;border:1px solid #555;border-bottom:2px solid #fff !important;text-align:center;width:8.33%">{{lang.vendor_address}}</th>
                                        <td style="border:1px solid #555;text-align:center;width:8.33%"><b-form-input v-if="canEdit" class="inborder" v-model="edit.vendor_address" /><span v-else>{{ billifno.vendor_address }}</span></td>
                                        <th style="background:#000 !important;color:#fff !important;border:1px solid #555;border-bottom:2px solid #fff !important;text-align:center;width:8.33%">{{lang.bill_type}}</th>
                                        <td style="border:1px solid #555;text-align:center;width:8.33%"><b-form-select v-if="canEdit" class="selborder" v-model="edit.cashajl" :options="cashajls" @change="onVatRuleChange()" /><span v-else>{{ cashajl }}</span></td>
                                    </tr>
                                    <tr v-if="canEdit">
                                        <th style="background:#000 !important;color:#fff !important;border:1px solid #555;border-bottom:2px solid #fff !important;text-align:center;width:8.33%">{{lang.vat}}</th>
                                        <td style="border:1px solid #555;text-align:center;width:8.33%">
                                            <b-form-select class="selborder" v-model="edit.vattype" :options="vattypes" @change="recalcAllRows()" />
                                        </td>
                                        <th style="background:#000 !important;color:#fff !important;border:1px solid #555;border-bottom:2px solid #fff !important;text-align:center;width:8.33%">{{lang.discount}}</th>
                                        <td style="border:1px solid #555;text-align:center;width:8.33%">
                                            <b-form-input class="inborder" type="number" v-model="edit.discount" />
                                        </td>
                                        <th style="background:#000 !important;color:#fff !important;border:1px solid #555;border-bottom:2px solid #fff !important;text-align:center;width:8.33%">{{lang.notes}}</th>
                                        <td style="border:1px solid #555;text-align:center;width:8.33%">
                                            <b-form-input class="inborder" v-model="edit.inv_notes" />
                                        </td>
                                    </tr>
                                </thead>
                            </b-table-simple>

                        </div>
                        <div class="container">
                            <div><h6>{{lang.invoice_details}}</h6></div>
                            <v-simple-table striped hover style="width:100%;">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th style="text-align:center;" class="backBlack">{{lang.item_code}}</th>
                                            <th style="text-align:center;" class="backBlack">{{lang.item_name}}</th>
                                            <th style="text-align:center;" class="backBlack">{{lang.qtty}}</th>
                                            <th style="text-align:center;" class="backBlack">{{lang.item_price}}</th>
                                            <th style="text-align:center;" class="backRed">{{lang.total}}</th>
                                            <th style="text-align:center;" class="backGreen">{{lang.vat}} 15%</th>
                                            <th style="text-align:center;" class="backBlack">{{lang.ftotal}}</th>
                                            <th style="text-align:center;" class="backBlack">{{lang.status}}</th>
                                            <th style="text-align:center;width:50px;" class="backBlue">{{ lang.action }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,index) in billifno.rows" :key="index">
                                            <td style="text-align:center;"><b-form-input class="inborder" type="text" :readonly="!canEdit" @change="getProduct(index)" v-model="billifno.rows[index].item_number" /></td>
                                            <td style="text-align:center;"><b-form-input class="inborder" type="text" :readonly="!canEdit" v-model="billifno.rows[index].item_name" /></td>
                                            <td style="text-align:center;"><b-form-input class="inborder" type="text" :readonly="!canEdit" @change="recalcRow(index)" v-model="billifno.rows[index].qty" /></td>
                                            <td style="text-align:center;"><b-form-input class="inborder" type="text" :readonly="!canEdit" @change="recalcRow(index)" v-model="billifno.rows[index].item_price" /></td>
                                            <td style="text-align:center;"><b-form-input class="inborder" type="text" v-model="billifno.rows[index].total" readonly /></td>
                                            <td style="text-align:center;"><b-form-input class="inborder" type="text" v-model="billifno.rows[index].vat" readonly /></td>
                                            <td style="text-align:center;"><b-form-input class="inborder" type="text" v-model="billifno.rows[index].ftotal" readonly /></td>
                                            <td style="text-align:center;">{{ item[`_status_${lang.langname}`] }}</td>
                                            <td style="text-align:center;white-space:nowrap;">
                                                <b-form-checkbox style="display:inline-block" @change="markMe(index)" v-if="item.is_returned==0" />
                                                <span v-if="canEdit" @click="removeRow(index)" style="cursor:pointer;color:#b00;font-weight:bold;padding:0 6px;" title="حذف السطر">&#10005;</span>
                                            </td>
                                            <!-- <td style="text-align:center;"></td> -->
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr   v-if="billifno.jvnum == 0 || billifno.jvnum == ''">
                                            <td style="text-align:center;"><b-form-input class="inborder" type="text" @change="getProduct(-1)" v-model="newrow.item_number" /></td>
                                            <td style="text-align:center;">
                                                <b-form-input class="inborder" list="items-list" @change="changeMe()" type="text" v-model="newrow.item_name" />
                                                <datalist id="items-list">
                                                    <option v-for="(item,index) in spareparts" :key="index">{{item.item_code}} -||- {{ item[`item_name${$parent.lang.langname}`] }}</option>
                                                </datalist>
                                            </td>
                                            <td style="text-align:center;"><b-form-input class="inborder" type="text" @change="updateTotal()" v-model="newrow.qty" /></td>
                                            <td style="text-align:center;"><b-form-input class="inborder" type="text" @change="updateTotal()" v-model="newrow.item_price" /></td>
                                            <td style="text-align:center;"><b-form-input class="inborder" type="text" v-model="newrow.total" readonly /></td>
                                            <td style="text-align:center;"><b-form-input class="inborder" type="text" v-model="newrow.vat" readonly /></td>
                                            <td style="text-align:center;"><b-form-input class="inborder" type="text" v-model="newrow.ftotal" readonly /></td>
                                            <td style="text-align:center;"></td>
                                            <td style="text-align:center;cursor:pointer;" @click="addNewRow()" class="backBlue">{{ lang.add }}</td>
                                        </tr>
                                        <tr>
                                            <th colspan="5" class="backEmpty"></th>
                                            <th :style="`text-align:`+lang.lalgin" class="backRed">{{lang.prices_exclusive_vat}}</th>
                                            <th :style="`background:lightgreen !important;text-align:`+lang.algin">{{totals}}</th>
                                            <th class="backEmpty" colspan="2"></th>
                                        </tr>
                                        <tr>
                                            <th colspan="5" class="backEmpty"></th>
                                            <th :style="`text-align:`+lang.lalgin" class="backBlack">{{lang.discount}}</th>
                                            <th :style="`text-align:`+lang.algin">{{edit.discount}}</th>
                                            <th class="backEmpty" colspan="2"></th>
                                        </tr>
                                        <tr>
                                            <th colspan="5" class="backEmpty"></th>
                                            <th :style="`text-align:`+lang.lalgin" class="backGreen">{{lang.vat}} 15%</th>
                                            <th :style="`background:lightgreen !important;text-align:`+lang.algin">{{vats}}</th>
                                            <th class="backEmpty" colspan="2"></th>
                                        </tr>
                                        <tr>
                                            <th colspan="5" class="backEmpty"></th>
                                            <th :style="`text-align:`+lang.lalgin" class="backBlack">{{lang.prices_include_vat}}</th>
                                            <th :style="`text-align:`+lang.algin">{{ftotals}}</th>
                                            <th class="backEmpty" colspan="2"></th>
                                        </tr>
                                    </tfoot>
                                </template>
                            </v-simple-table>
                            <div style="display:none;"><h6>{{lang.payments}}</h6></div>
                            <v-simple-table striped hover style="width:100%;display:none;">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th style="text-align:center;">{{lang.date}}</th>
                                            <th style="text-align:center;">{{lang.amounttotal}}</th>
                                            <th style="text-align:center;">{{lang.payment_method}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,index) in payrows" :key="index">
                                            <td>{{item.receipt_date}}</td>
                                            <td>{{item.ftotal}}</td>
                                            <td>{{item.paytype}}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </div>
                    <purchaseCardGallery ref="viewCardGall" />
                    <addNewProduct ref="addProducts" />
                </template>
                <template #footer="" class="shadow">

                </template>

            </b-sidebar>
        </v-form>
    </div>
</template>


<script>
import axios from 'axios'
import purchaseCardGallery from './purchaseCardGallery.vue';
import {SnotifyPosition} from 'vue-snotify';
import addNewProduct from '@/components/addNewProduct-old-view.vue';
export default{
  components: { purchaseCardGallery, addNewProduct },
    name: 'ViewPurchase',
    data() {
        return {
            spareparts: [],
            shwoDelInv: true,
            shwoDelPartInv: true,
            showPost: true,
            totals: 0,
            vats: 0,
            ftotals: 0,
            billid: 0,
            workingAction:false,
            billifno: { rows: [] },
            payrows: [],
            selected: [],
            returned: [],
            newrow: {
                item_number: '',
                item_name: '',
                qty: '',
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
            },
            Working: false,
            showPostD: true,
            // The editable copy of the header, kept apart from billifno because
            // that one carries display text -- getBillinfo turns paytype into
            // "فاتورة آجلة" on a credit document -- which must never be saved back.
            edit: {},
            savingBill: false,
            paytypes: [],
            vattypes: [
                {text: 'أسعار بدون ضريبة', value: 1},
                {text: 'أسعار غير شاملة الضريبة', value: 2},
                {text: 'أسعار شاملة الضريبة', value: 3},
            ],
            invtypes: [
                {text: 'فاتورة مشتريات', value: 1},
                {text: 'فاتورة داخلية', value: 2},
            ],
            cashajls: [
                {text: 'نقدي', value: 1},
                {text: 'آجل', value: 2},
            ],
        }
    },
    created() {
        // this.getBill();
        this.getPays();
        this.getPayTypes();
        this.getInvSettings();
    },
    methods: {
        async purchaseAction(type,id,flag){
 if(this.workingAction)return false;this.workingAction=true;
 const post=new FormData();post.append('defBranch',localStorage.getItem('defBranch'));post.append('financeYear',localStorage.getItem('financeYear'));post.append('type',type);post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));post.append('data[id]',id);post.append('data[doc]','purchase');
 try{
  const {data:res}=await axios.post(this.$store.state.SAMCOTEC.r_path,post);
  if(Number(res?.error?.number)!==200||res?.results?.data?.[flag]!==true)throw new Error('purchase_unconfirmed');
  if(flag==='deleted'){this.$refs.purchaseViewer.hide();this.billifno={rows:[]};this.edit={};}
  else await this.getBill();
  if(this.$parent.getInvoice)await this.$parent.getInvoice();return true;
 }catch(error){const code=error.response?.data?.error?.code;this.$snotify.error(this.lang[code]||this.lang.purchase_action_failed,this.lang.alert,{timeout:8000});return false;}
 finally{this.workingAction=false;this.showPost=true;this.showPostD=true;}
},
        getInvSettings() {
            if(this.$store.state.settings.vat_number == ''){
                this.invoice.vtype = 1;
            }
            const post = new FormData();
            post.append('type','getInvSettings');
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[all]','all');
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then(
                (response) => {
                    const res = response.data;
                    if(res != '' && res.error.number == 200){
                        // console.log("getinv",res.results.data.products);
                        if(res.results.data.products.length != 0){
                            this.allProducts = res.results.data.products;
                            this.spareparts = res.results.data.products;
                            // for(let i= 0; i < res.results.data.products.length; i++){
                            //     this.spareparts.push(res.results.data.products[i].name);
                            // }
                        }
                    }
                }
            )
        },
        deletePost(id){
            this.showPostD = false;
            let message = this.$parent.lang.post_purchase_note;
            this.$snotify.error(message, this.$parent.lang.alert, {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.$parent.lang.agree,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                            this.deltePostOK(id)
                        }
                    },
                    {
                        text: this.$parent.lang.cancel,
                        action: (toast) => {
                            this.showPostD = true;
                            this.$snotify.remove(toast.id);
                        }
                    },
                ]
            });
            return false;
        },
        deltePostOK(id){return this.purchaseAction('deletePurchasePost',id,'unposted');},
        rePost(id){return this.purchaseAction('rePostPurchase',id,'posted');},
        showAttached(){
            this.$refs.viewCardGall.card.cardid = this.billid;
            this.$refs.viewCardGall.getImages();

        },
        updateTotal(){
            if(this.newrow.qty == '') this.newrow.qty = 1
            if(this.newrow.item_price == '') this.newrow.item_price = 0
            let total = parseFloat(this.newrow.qty) * parseFloat(this.newrow.item_price)
            // Same three cases as everywhere else: 1 no VAT, 2 the price
            // excludes it, 3 the price includes it. This used to add 15% on top
            // of a price that already contained it whenever the type was not 1.
            const cal = this.$calcVat(total, Number(this.edit.vattype || this.billifno.vattype) || 2,Number(this.$store.state.settings.def_vat??15)/100);
            this.newrow.total = this.$RoundNums(cal.tot,2);
            this.newrow.vat = this.$RoundNums(cal.vat,2);
            this.newrow.ftotal = this.$RoundNums(cal.ftot,2);
        },
        addNewRow(){
            if(this.Working) {
                return false;
            }
            if(this.newrow.item_number == "" && this.$store.state.licenseType.require_itemcode){
                let message = this.lang.item_code_required;
                this.$snotify.error(message, this.$parent.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.cancel,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                this.resetNewRow();
                return false;
            }
            if(this.newrow.item_price == "" || this.newrow.item_price == 0){
                let message = this.lang.item_price_required;
                this.$snotify.error(message, this.$parent.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.cancel,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
            let go = false;
            for(let i=0;i<this.billifno.rows.length;i++) {
                if(this.newrow.item_number == this.billifno.rows[i].item_number){
                    go = true;
                }
            }
            if(go) {
                this.resetNewRow();
                let message = this.lang.item_already_exists;
                this.$snotify.error(message, this.$parent.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.cancel,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","addNewRowToPurchase");
            post.append('data[doc]','purchase');
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[row]',JSON.stringify(this.newrow));
            post.append('data[billid]',this.billid);
            post.append('data[bill_date]',this.billifno.bill_date);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                this.resetNewRow();
                this.getBill();
            });
        },
        changeMe(){
            this.newrow.item_number = '';
            const itemn = this.newrow.item_name.split(" -||- ");
            // this.resetNewRow();
            if(itemn.length > 1){
                this.newrow.item_number = itemn[0];
            }
            this.getProduct();
        },
        getProduct(){
            if(this.newrow.item_number == '' && this.$store.state.licenseType.require_itemcode){
                let message = this.lang.item_code_required;
                this.$snotify.error(message, this.$parent.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                this.resetNewRow();
                return false;
            }
            this.Working = true;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getProducts");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[item_number]',this.newrow.item_number);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                if(response.data.results.data.length > 0){
                    if(response.data.results.data[0].item_type == 1){
                        this.newrow.item_number = response.data.results.data[0].item_code;
                        this.newrow.item_name = response.data.results.data[0].item_namear;
                        this.newrow.item_price = response.data.results.data[0].default_price;
                        this.newrow.unit_id = response.data.results.data[0].main_unit;
                        this.newrow.unit = response.data.results.data[0].main_unit;
                        this.itemUnits = response.data.results.data[0].itemUnits;
                    }
                }
                else if(this.$store.state.licenseType.item_card_required) {
                    this.newrow.item_number = '';
                    let message = this.lang.item_not_found_add_card;
                    this.$snotify.error(message, this.$parent.lang.alert, {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.$parent.lang.close,
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                }
                            },
                        ]
                    });
                    this.resetNewRow();
                    return false;

                }
                // this.calcKit();
                this.Working = false;
            })
        },
        resetNewRow(){
            this.newrow = {
                item_number: '',
                item_name: '',
                qty: '',
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
            }
        },
        addNewP(){
            this.$refs.addProducts.resetAll();
        },
        deleteSelected() {
            let message = this.$parent.lang.are_you_sure;
            this.$snotify.error(message, this.$parent.lang.alert, {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.$parent.lang.agree,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                            this.deleteSelected1()
                        }
                    },
                    {
                        text: this.$parent.lang.cancel,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                        }
                    },
                ]
            });
            return false;
        },
        deleteSelected1(){
            if(this.selected.length == 0){
                alert(this.lang.no_row_selected);
                return false;
            }
            if(this.billifno.rows.length == 1){
                this.deleteAll();
                return false;
            }
            this.shwoDelInv = false;
            this.shwoDelPartInv = false;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','deleteSelected');
            post.append('data[doc]','purchase');
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',JSON.stringify(this.selected));
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                this.shwoDelInv = true;
                this.shwoDelPartInv = true;
                const res = response.data;
                this.getBill();
                this.$parent.getInvoice();
                alert(this.lang.selected_deleted);
                document.getElementById('viewBillHide').click();
            });
        },
        returnSelected(){
            if(this.selected.length == 0){
                alert(this.lang.no_row_selected);
                return false;
            }
            console.log(this.selected);
            this.shwoDelInv = false;
            this.shwoDelPartInv = false;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','returnSelected');
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            let dat = [];


            post.append('data[id]',JSON.stringify(this.selected));
            post.append('data[vattype]',this.billifno.vattype);
            post.append('data[billid]',this.billifno.billid);
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                this.shwoDelInv = true;
                this.shwoDelPartInv = true;
                const res = response.data;
                this.getBill();
                this.$parent.getInvoice();
                alert(this.lang.selected_returned);
                document.getElementById('viewBillHide').click();
            });
        },
        returnAll(){
            this.shwoDelInv = false;
            this.shwoDelPartInv = false;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','retPurchase');
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',this.billifno.id);
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                this.shwoDelInv = true;
                this.shwoDelPartInv = true;
                const res = response.data;
                this.$parent.getInvoice();
                alert(this.lang.invoice_returned);
                document.getElementById('viewBillHide').click();
            });
        },
        deleteAll(){return this.purchaseAction('delPurchase',this.billifno.id,'deleted');},
        markMe(index){
            let added = true;
            for(let i=0;i<this.selected.length;i++){
                if(this.billifno.rows[index].id == this.selected[i]){
                    added = false;
                    this.selected.splice(i,1);
                }
            }
            if(added){
                this.selected.push(this.billifno.rows[index].id)
            }
            let rets = true;
            for(let i=0;i<this.returned.length;i++){
                if(index == this.returned[i]){
                    rets = false;
                    this.returned.splice(i,1);
                }
            }
            if(rets){
                this.returned.push(index)
            }
        },
        getPays(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getbillPayments');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[id]',this.billid);
             axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            ).then((resp) => {
                const res = resp.data;
                // // console.log(res);
                this.payrows = res.results.data;

            })
        },
        // --- editing a draft ------------------------------------------------
        // The document is editable exactly while it has no journal. Posting
        // writes the ledger and moves the stock against the rows as they stand,
        // so from that moment the rows are evidence, not a draft. Unpost to edit.
        seedEdit(){
            const raw = this.billifno.raw || {};
            this.edit = {
                bill_number: this.billifno.bill_number,
                vendor: this.billifno.vendor,
                vendorid: raw.vendorid,
                mobile: this.billifno.mobile,
                vat_number: this.billifno.vat_number,
                vendor_address: this.billifno.vendor_address,
                bill_date: String(raw.bill_date || this.billifno.bill_date || '').substr(0,10),
                paytype: Number(raw.paytype || 0),
                vattype: Number(raw.vattype || 2),
                invtype: Number(raw.invtype || 1),
                cashajl: Number(raw.cashajl || 1),
                discount: raw.discount || 0,
                inv_notes: raw.inv_notes || '',
            };
        },
        // An internal invoice carries no VAT. The create form applies that rule,
        // so the edit form has to as well or the two screens disagree.
        onVatRuleChange(){
            if(Number(this.edit.invtype) === 2) this.edit.vattype = 1;
            this.recalcAllRows();
        },
        recalcRow(index){
            const row = this.billifno.rows[index];
            if(!row) return;
            const qty = parseFloat(row.qty) || 0;
            const price = parseFloat(row.item_price) || 0;
            const cal = this.$calcVat(qty * price, Number(this.edit.vattype) || 2,Number(this.$store.state.settings.def_vat??15)/100);
            this.$set(this.billifno.rows[index], 'total', this.$RoundNums(cal.tot,2));
            this.$set(this.billifno.rows[index], 'vat', this.$RoundNums(cal.vat,2));
            this.$set(this.billifno.rows[index], 'ftotal', this.$RoundNums(cal.ftot,2));
            this.recalcTotals();
        },
        recalcAllRows(){
            for(let i = 0; i < (this.billifno.rows || []).length; i++) this.recalcRow(i);
            this.updateTotal();
        },
        recalcTotals(){
 const type=Number(this.edit.vattype||this.billifno.vattype||2);const base=(this.billifno.rows||[]).reduce((total,row)=>total+(parseFloat(row[type===3?'ftotal':'total'])||0),0)-(parseFloat(this.edit.discount)||0);
 const split=this.$calcVat(base,type,Number(this.$store.state.settings.def_vat??15)/100);this.totals=this.$RoundNums(split.tot,2);this.vats=this.$RoundNums(split.vat,2);this.ftotals=this.$RoundNums(split.ftot,2);
},
        removeRow(index){
            this.billifno.rows.splice(index,1);
            this.recalcTotals();
        },
        async saveBill(){
 if(this.savingBill||this.workingAction||!this.canEdit)return false;this.savingBill=true;
 const rows=(this.billifno.rows||[]).map(row=>({id:row.id,item_number:row.item_number,item_name:row.item_name,qty:row.qty,item_price:row.item_price,unit:row.unit||1}));
 const post=new FormData();post.append('defBranch',localStorage.getItem('defBranch'));post.append('financeYear',localStorage.getItem('financeYear'));post.append('type','updatePurchaseBill');post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));post.append('data[id]',this.billid);post.append('data[bill]',JSON.stringify(this.edit));post.append('data[rows]',JSON.stringify(rows));
 try{const {data:res}=await axios.post(this.$store.state.SAMCOTEC.r_path,post);if(Number(res?.error?.number)!==200||res?.results?.data?.saved!==true)throw Error('purchase_unconfirmed');this.$snotify.success(this.lang.successfuly_job,this.lang.alert,{timeout:3000});await this.getBill();if(this.$parent.getInvoice)await this.$parent.getInvoice();return true;}
 catch(error){this.$snotify.error(this.lang[error.response?.data?.error?.code]||this.lang.purchase_action_failed,this.lang.alert,{timeout:8000});return false;}
 finally{this.savingBill=false;}
},
        getPayTypes() {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getPayTypes");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[all]',1);
            post.append('data[pur]',1);
            post.append('data[id]','all');
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                const res = response.data;
                const rows = (res && res.results && res.results.data) ? res.results.data : [];
                this.paytypes = rows.map((p) => ({
                    text: (this.lang.langname == 'ar') ? p.type_name : p.type_name_en,
                    value: p.id
                }));
            }).catch(() => { this.paytypes = []; });
        },
        async getBill(){
 const requested=this.billid;this.billifno={rows:[]};this.edit={};this.selected=[];this.returned=[];
 const post=new FormData();post.append('defBranch',localStorage.getItem('defBranch'));post.append('financeYear',localStorage.getItem('financeYear'));post.append('type','getBillinfo');post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));post.append('data[id]',requested);
 try {
  const {data:res}=await axios.post(this.$store.state.SAMCOTEC.r_path,post);
  if(requested!==this.billid)return false;
  const bill=res?.results?.data;
  if(Number(res?.error?.number)!==200||!bill||Number(bill.id)!==Number(requested)||!Array.isArray(bill.rows))throw new Error('purchase_not_found');
  this.billifno={...bill,bill_date:String(bill.bill_date||'').substring(0,10)};this.seedEdit();
  this.totals=bill.total;this.vats=bill.vat;this.ftotals=bill.ftotal;return true;
 }catch(error){if(requested===this.billid)this.$snotify.error(this.lang.purchase_load_failed,this.lang.alert,{timeout:6000});return false;}
}
    },
    computed: {
        // A document with a journal number has been posted: its ledger entries
        // and its stock movements already exist and were built from these rows.
        canEdit: function(){
            return Number(this.billifno.id)>0 && (this.billifno.jvnum == 0 || this.billifno.jvnum == '' || typeof this.billifno.jvnum === 'undefined')
                && this.billifno.is_returned != 1;
        },
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        shoCancelPost: function() {
            if(!Array.isArray(this.billifno.rows))return false;
            for(let j=0;j < this.billifno.rows.length; j++){
                if((this.billifno.rows[j].is_returned != 0 && this.billifno.rows[j].is_returned != '') && this.billifno.rows[j].qty_already_returned != 0 ){
                    return false;
                }
            }
            return this.showPostD && this.billifno.is_returned == 0 && this.billifno.jvnum != 0 && this.billifno.jvnum != '';
        },
        shoReturnInvo: function() {
            if(!Array.isArray(this.billifno.rows))return false;
            for(let j=0;j < this.billifno.rows.length; j++){
                if(this.billifno.rows[j].is_returned != 0 && this.billifno.rows[j].is_returned != ''){
                    return false;
                }
            }
            return true;
        },
        cashajl: function(){
            if(this.billifno.cashajl == 1){
                return this.lang.paid_invoice;
            }
            return this.lang.none_paid_invoice;
        },
        bobtitle: function(){
            if(Number(this.billifno.expeneses_type||0)===0){
                return this.lang.view_purchase_bill.substring(4)
            }
            return this.lang.expenses
        },
        view_title: function(){
            if(Number(this.billifno.expeneses_type||0)===0){
                return this.lang.view_purchase_bill
            }
            return this.lang.view_expenses
        },
        items: function(){
            return {
                    text: this.lang.view_purchase_bill,
                    disabled: true,
                    to: '/view-purchase',
                }
        }
    },
}
</script>
<style>
.rowDiv{
    width:48%;
    margin-inline-end: 1%;
    padding:5px;
}
.rowDivFull{
    width:98%;
    margin-inline-end: 2%;
    margin-inline-start: 1%;
    padding:5px;
}
.myBtn{
    flex-wrap: wrap;
    display:flex;
    flex-direction: row;
    justify-content: center;
    justify-items: center;
    align-items: stretch;
    margin-top:5px;
}
.mySubBtn{
    flex-wrap: wrap;
    display:none;
    flex-direction: row;
    justify-content: start;
    justify-items: center;
    align-items: center;
    margin-top:5px;
}
.btnRow{
    min-width:100px;
    padding:5px 5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    justify-items: center;
    align-items: center;
    margin-inline-end:5px;
    border:2px solid #fff;
    cursor: pointer;
    font-weight: bolder;
    overflow-anchor: none;
    border-radius: 5px;
    margin-top:10px;
    margin-bottom:10px;
    margin-inline-end:10px !important;
}
.btnRowF{
    min-width:120px;
    padding:5px 5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    justify-items: center;
    align-items: center;
    margin-inline-end:5px;
    border:2px solid #fff;
    cursor: pointer;
    overflow-anchor: none;
    border-radius: 5px;
    margin-top:10px;
    margin-bottom:10px;
}
.c_blue{
    background:blue !important;
    color:#fff !important;
}
.c_darkblue{
    background:darkblue !important;
    color:#fff !important;
}
.c_green{
    background:green !important;
    color:#fff !important;
}
.c_red{
    background:red !important;
    color:#fff !important;
}
.c_darkslategrey{
    background:darkslategrey !important;
    color:#fff !important;
}
.c_darkgreen{
    background:darkgreen !important;
    color:#fff !important;
}
.c_darkcyan{
    background:darkcyan !important;
    color:#fff !important;
}
.c_darkolivegreen{
    background:darkolivegreen !important;
    color:#fff !important;
}
.c_darkslateblue{
    background:darkslateblue !important;
    color:#fff !important;
}
.c_darkorange{
    background:darkorange !important;
    color:#fff !important;
}
.c_darkorchid{
    background:darkorchid !important;
    color:#fff !important;
}
.c_lightgray{
    background:#d1d1d1 !important;
    color:#000 !important;
}
.c_black{
    background:#000 !important;
    color:#fff !important;
}
.c_lightgray i{
    display:none;
}
</style>